/*
 * Copyright (c) Dito Technologies
 */

import {graphql} from "babel-plugin-relay/macro";
import {
    ChangeMusicPieceNameMutation$data,
    ChangeMusicPieceNameMutation$variables
} from "mutation/__generated__/ChangeMusicPieceNameMutation.graphql";
import perform from "mutation/perform";

const mutation = graphql`
    mutation ChangeMusicPieceNameMutation($input: MusicChangePieceNameInput!) {
        music_change_piece_name(input: $input) {
            piece {
                id
                name
            }
        }
    }
`

export default function ChangeMusicPieceName(pieceId: string, name: string) {
    const variables: ChangeMusicPieceNameMutation$variables = {
        input: {
            piece_id: pieceId,
            name: name
        }
    }
    return perform<ChangeMusicPieceNameMutation$data>(mutation, variables);
}